import React, { useState, useEffect } from 'react';
import constant from '../../constant';
import { v2_ships } from '../../actions/v2/projectAndVessel';
import { toast } from 'react-toastify';
import { v2_categories, v2_channels, v2_plan_type } from '../../actions/v2/masterData';
import { v2_all_user } from '../../actions/v2/user';
import { v3_upload_plan_approval_document } from '../../actions/v3/planApproval';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import RemarksSelect from '../common/RemarksSelect';
import { uploadSelectedFiles } from '../../utils/multipleFileUpload';

const decodeMojibake = (value) => {
    if (!value || typeof value !== 'string' || value.includes('�')) return value;

    const decodeOnce = (input) => {
        if (!/[\u00C0-\u00FF]/.test(input)) return input;
        if (typeof TextDecoder === 'undefined' || typeof TextEncoder === 'undefined') return input;

        try {
            const sourceBytes = Uint8Array.from(input, (ch) => ch.charCodeAt(0) & 0xff);
            const decoded = new TextDecoder('utf-8', { fatal: false }).decode(sourceBytes);
            if (!decoded || decoded.includes('\u0000')) return input;

            const reEncoded = new TextEncoder().encode(decoded);
            if (reEncoded.length !== sourceBytes.length) return input;

            for (let i = 0; i < reEncoded.length; i += 1) {
                if (reEncoded[i] !== sourceBytes[i]) return input;
            }

            return decoded;
        } catch (error) {
            return input;
        }
    };

    let current = value;
    for (let i = 0; i < 2; i += 1) {
        const next = decodeOnce(current);
        if (next === current) break;
        current = next;
    }

    return current;
};

const mapDocumentForEdit = (doc) => ({
    fileName: doc.FILE_NAME || doc.fileName,
    originalFileName: decodeMojibake(doc.ORIGINAL_FILE_NAME || doc.originalFileName),
    existing: true
});

const getUploadedFiles = (files = []) => (
    Array.isArray(files)
        ? files.filter((file) => file?.fileName && file?.originalFileName)
        : []
);

const CreatePlanApprovalForm = ({ projectId, documents = [], onSubmit, data }) => {

    const [state, setState] = useState({
        subject: { name: 'subject', value: data ? data.SUBJECT : '', isRequired: true, error: '' },
        hullId: { name: 'hullId', value: data ? data.SHIP_ID : '', options: [], isRequired: true, error: '' },
        channelId: { name: 'channelId', value: data ? data.CHANNEL_ID : '', options: [], isRequired: true, error: '' },
        categoryId: { name: 'categoryId', value: data ? data.CATEGORY_ID : '', options: [], isRequired: true, error: '' },
        remarks: { name: 'remarks', value: data ? data.REMARK : '', isRequired: true, error: '' },
        assigned_user_id: { name: 'assigned_user_id', value: data ? data.ASSIGNED_USER_ID : '', isRequired: true, error: '' },
        submitted_to_user_id: { name: 'submitted_to_user_id', value: data ? data.SUBMITTED_TO_USER_ID : '', isRequired: true, error: '' },
        // reference_number: { name: 'reference_number', value: data ? data.REFERENCE_NUMBER : '', isRequired: false, error: '' },
        attended_by: { name: 'attended_by', value: data ? data.ATTENDED_BY : '', isRequired: true, error: '' },
        scheduleDate: { name: 'scheduleDate', value: data ? data.SCHEDULE_DATE : '', isRequired: false, error: '' },
        acceptedDate: { name: 'acceptedDate', value: data ? data.ACCEPTED_DATE : '', isRequired: false, error: '' },
        documentFiles: {
            name: 'documentFiles',
            value:
                data
                    ? (documents?.map(mapDocumentForEdit) || [])
                    : [{ fileName: '', originalFileName: '', existing: false }],
            isRequired: false,
            error: ''
        },
        // documentFiles: { name: 'documentFiles', value: [{ fileName: '', originalFileName: '' }], isRequired: false, error: '' },
        // documentFiles: { name: 'documentFiles', value: documents, isRequired: false, error: '' },
    });

    useEffect(() => {
        if (data) {
            const mapped = (documents || []).map(mapDocumentForEdit);

            setState(prev => ({
                ...prev,
                documentFiles: {
                    ...prev.documentFiles,
                    value: mapped.length ? mapped : [],
                    error: ''
                }
            }));
        }
    }, [data, documents]);

    useEffect(() => {
        v2_ships(null, projectId, null).then((res) => {
            if (res.status) {
                if (res.status) {
                    setState(prev => ({
                        ...prev,
                        hullId: {
                            ...prev.hullId,
                            options: res.result.map((item) => {
                                return {
                                    ...item,
                                    id: item.ID,
                                    name: item.HULL_NUMBER + ' - ' + item.SHIP_NAME
                                }
                            }) || []
                        }
                    }))
                }
            }
            else {
                toast.error(res.error || res.error.message)

            }
        })

        v2_categories().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['categoryId']: {
                        ...prev['categoryId'],
                        options: res.result.map((item) => {
                            return {
                                id: item.ID,
                                name: item.CATEGORY_NAME
                            }
                        }) || []
                    }
                }));
            }
        })
        v2_channels().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['channelId']: {
                        ...prev['channelId'],
                        options: res.result.map((item) => {
                            return {
                                id: item.ID,
                                name: item.CHANNEL_NAME
                            }
                        }) || []
                    }
                }));
            }
        })

        v2_all_user().then((res) => {
            if (res.status) {
                setState(prev => ({
                    ...prev,
                    ['assigned_user_id']: {
                        ...prev['assigned_user_id'],
                        options: res.result.map((item) => {
                            return {
                                id: item.USER_ID,
                                name: item.FULL_NAME
                            }
                        }) || []
                    },
                    ['submitted_to_user_id']: {
                        ...prev['submitted_to_user_id'],
                        options: res.result.map((item) => {
                            return {
                                id: item.USER_ID,
                                name: item.FULL_NAME
                            }
                        }) || []
                    },
                    ['attended_by']: {
                        ...prev['attended_by'],
                        options: res.result.map((item) => {
                            return {
                                id: item.USER_ID,
                                name: item.FULL_NAME
                            }
                        }) || []
                    }
                }));
            }
        })

    }, [])

    const replaceFileAtIndex = (index) => {
        const updatedFiles = [...state.documentFiles.value];
        updatedFiles[index] = { fileName: '', originalFileName: '', existing: false }; // clears so file input appears
        setState(prev => ({
            ...prev,
            documentFiles: { ...prev.documentFiles, value: updatedFiles, error: '' }
        }));
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };

    const renderInput = (label, name, placeholder = '') => (
        <div className="col-md-6 mb-3" key={name}>
            <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
            <input
                type="text"
                name={name}
                value={state[name].value}
                placeholder={placeholder}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            />
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );
    const renderDate = (label, name, placeholder = '') => (
        <div className="col-md-6 mb-3" key={name}>
            <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
            <input
                type="date"
                name={name}
                value={state[name].value}
                placeholder={placeholder}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            />
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );

    const renderSelect = (label, name, options = []) => (
        <div className="col-md-6 mb-3" key={name}>
            <label>{label} {state[name].isRequired && <span className='text-danger'> *</span>}</label>
            <select
                name={name}
                value={state[name].value}
                onChange={handleChange}
                className={`form-control ${state[name].error ? 'is-invalid' : ''}`}
            >
                <option value="">Select {label}</option>
                {options.map(opt => (
                    <option key={opt.id} value={opt.id}>{opt.name}</option>
                ))}
            </select>
            {state[name].error && <div className="invalid-feedback">{state[name].error}</div>}
        </div>
    );
    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...state };

        Object.keys(state).forEach((key) => {
            if (state[key].isRequired && !state[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }

        // 2. Build payload
        const payload = {
            projectId,
            subject: state.subject.value,
            shipId: state.hullId.value,
            channelId: state.channelId.value,
            categoryId: state.categoryId.value,
            remarks: state.remarks.value,
            assign_user: state.assigned_user_id.value,
            submitted_user: state.submitted_to_user_id.value,
            // referenceNumber: state.reference_number.value,
            attendedBy: state.attended_by.value,
            scheduleDate: state.scheduleDate.value,
            acceptedDate: state.acceptedDate.value,
            documentFiles: getUploadedFiles(state.documentFiles.value)
        };

        onSubmit(payload)
    };

    const handleFileChange = async (index, files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_plan_approval_document);
        if (!uploadedFiles.length) return;

        setState(prev => {
            const updatedFiles = [...prev.documentFiles.value];
            updatedFiles.splice(index, 1, ...uploadedFiles.map((file) => ({ ...file, existing: false })));
            return {
                ...prev,
                documentFiles: { ...prev.documentFiles, value: updatedFiles, error: '' }
            };
        });
    };

    const addFileField = () => {
        setState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: [...prev.documentFiles.value, { fileName: '', originalFileName: '', existing: false }],
                error: ''
            }
        }));
    };

    const removeFileField = (index) => {
        const updatedFiles = state.documentFiles.value.filter((_, i) => i !== index);
        setState(prev => ({
            ...prev,
            documentFiles: {
                ...prev.documentFiles,
                value: updatedFiles,
                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
            }
        }));
    };
    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                {renderInput('Subject', 'subject', 'Enter Subject')}
                {renderSelect('Hull', 'hullId', state.hullId.options)}
                {renderSelect('Channel', 'channelId', state.channelId.options)}
                {renderSelect('Category', 'categoryId', state.categoryId.options)}
                {renderSelect('Assigned To', 'assigned_user_id', state.assigned_user_id.options)}
                {renderSelect('Submitted To', 'submitted_to_user_id', state.submitted_to_user_id.options)}
                {/*{renderInput('Reference Number', 'reference_number', 'Enter Reference Number')}*/}
                {renderSelect('Attended By', 'attended_by', state.attended_by.options)}
                {renderDate('Schedule Date', 'scheduleDate')}
                {renderDate('Accepted Date', 'acceptedDate')}
                <RemarksSelect
                    label="Remark"
                    name="remarks"
                    value={state.remarks.value}
                    onChange={handleChange}
                    error={state.remarks.error}
                    required={state.remarks.isRequired}
                    placeholder="Enter remarks"
                />

                <div className="col-md-12 mb-3">
                    <label>Upload Documents</label>

                    {state.documentFiles.value.map((item, index) => (
                        <div key={index} className="d-flex align-items-center mb-2">
                            {item.fileName ? (
                                <>
                                    <div className="me-2 flex-grow-1">
                                        <span>{decodeMojibake(item.originalFileName || item.fileName)}</span>
                                    </div>

                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary me-2"
                                        onClick={() => replaceFileAtIndex(index)}
                                    >
                                        Replace
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-outline-danger"
                                        onClick={() => removeFileField(index)}
                                    >
                                        <FaTrash />
                                    </button>
                                </>
                            ) : (
                                <>
                                    <input
                                        type="file"
                                        multiple
                                        onChange={(e) => handleFileChange(index, e.target.files)}
                                        className="form-control me-2"
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger"
                                        onClick={() => removeFileField(index)}
                                    >
                                        <FaTrash />
                                    </button>
                                </>
                            )}
                        </div>
                    ))}

                    <div>
                        <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={addFileField}
                        >
                            <FaPlus className="me-1" /> Add Document
                        </button>
                    </div>

                    {state.documentFiles.error && (
                        <div className="text-danger mt-1">{state.documentFiles.error}</div>
                    )}
                </div>
            </div>

            <div className="mt-3">
                <button type="submit" className="btn btn-success me-2">Submit</button>
                <Link className="btn btn-danger text-white" to={{
                    pathname: constant.Authedcomponent.fatProject.url,
                    state: {
                        projectId
                    }
                }}>Cancel</Link>
            </div>
        </form>
    );
};

export default CreatePlanApprovalForm;
